module.exports = __webpack_public_path__ + "static/img/notify-gosaas.83ef921.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/notify-gosaas.png
// module id = fmBm
// module chunks = 134